<template>
	<select v-if="options.length > 0"
			:value="value"
			@input="$emit('input', $event.target.value)"
			:disabled="disabled"
	>
		<option disabled selected :value="null">{{ config.placeholder }}</option>
		<option
			v-for="option in options" :key="option[config.value]" :value="option[config.value]"
		>{{ option[config.label] }}
		</option>
	</select>
</template>

<script>
import {QueuedFile} from "@/common/queued-file";
import LoadingIndicator from "@/components/LoadingIndicator";
import {client} from "@/store";
import {CheckIcon, FolderPlusIcon, PlusIcon, RotateCcwIcon, XIcon} from "vue-feather-icons";
import {mapActions, mapGetters} from "vuex";

export default {
	components: {},
	data() {
		return {
			options: []
		};
	},

	props: {
		config: {
			type: Object,
			default: ""
		},
		disabled: {
			type: Boolean,
			default: false
		},
		variables: {
			type: Object,
			default: {}
		},
		value: {
			type: String | Number,
			default: ""
		}
	},

	created() {
		this.getData();
	},
	methods: {
		getData() {
			const variableData = {};
			this.config.variables.forEach(variable => {
				variableData[variable] = this.variables[variable];
			});
			const query = atob(this.config.query);
			client.query(query, variableData)
				.then(response => {
					this.options = this.config.dataPath.reduce((data, path) => data[path], response);
				})
				.catch(error => {
					console.log(error);
				});
		}
	}
};
</script>

<style scoped lang="scss">

</style>
